<template>
  <main class="main bgPage">
    <div v-if="resCol === '6'" class="pa-3" style="background-color: #16163f;color: white;display: flex;padding-right: 70px !important;;padding-left: 70px !important;justify-content: space-between;">
      <div style="display: flex;">
        <div class="mr-3">
          <v-icon color="white" class="mr-2">mdi-email</v-icon>support@betaskthai.com
        </div>
        <div class="mr-3">
          <v-icon color="white" class="mr-2">mdi-phone</v-icon>089-456-2288
        </div>
        <div>
          <v-icon color="white" class="mr-2">mdi-phone</v-icon>08-1929-3917
        </div>
      </div>
      <div style="display: flex;">
        <div style="background-color: #09a909;background-color: rgb(9, 169, 9);border-radius: 34px;padding: 2px;padding-right: 10px;padding-left: 10px;font-size: 13px;" class="mr-5">
          <v-icon class="iconify" color="white" data-icon="cib:line"></v-icon> ADD FREIND
        </div>
        <v-icon color="white" class="mr-5">mdi-facebook</v-icon>
        <!-- <v-ico >mdi-facebook</v-ico> -->
        <v-icon class="iconify mr-5" data-icon="cib:tiktok"  color="white"></v-icon>
        <v-icon color="white" class="mr-5">mdi-youtube</v-icon>
        <v-icon color="white" class="mr-5">mdi-twitter</v-icon>
      </div>
    </div>
    <Navbar />
    <div style="padding: 25px">
    <div>
      <div v-if="resCol === '6'" style="display: flex; margin: 0 auto; width: 700px">
        <div style="text-align: center">
          <v-avatar color="#FFFFFF" size="70">
            <span class="black--text text-h4">1</span>
          </v-avatar>
          <div style="white-space: nowrap; margin-top: 20px; font-size: 19px;color: #FFFFFF;" >
            สมัครสมาชิกบริษัท/ ร้าน
          </div>
        </div>
        <hr />
        <div style="text-align: center">
          <v-avatar color="#FFFFFF" size="70">
            <span class="black--text text-h4">2</span>
          </v-avatar>
          <div style="white-space: nowrap; margin-top: 20px; font-size: 19px;color: #FFFFFF;">
            สร้างบัญชี Line Official Account
          </div>
        </div>
        <hr />
        <div style="text-align: center; margin-left: 30px">
          <v-avatar color="grey" size="70">
            <span class="white--text text-h4">3</span>
          </v-avatar>
          <div style="white-space: nowrap; margin-top: 20px; font-size: 19px;color: #FFFFFF;">
            เข้าสู่ระบบ
          </div>
        </div>
      </div>
      <div v-if="resCol === '12'" style="display: flex; margin: 0 auto; width: 300px;">
        <div style="text-align: center;">
          <v-avatar color="#1C3879" size="50">
            <span class="white--text text-h7">1</span>
          </v-avatar>
          <div style="white-space: nowrap; margin-top: 10px; font-size: 14px">
            สมัครสมาชิก
          </div>
        </div>
        <hr style="margin-top: 20px;"/>
        <div style="text-align: center">
          <v-avatar color="#1C3879" size="50">
            <span class="white--text text-h7">2</span>
          </v-avatar>
          <div style="white-space: nowrap; margin-top: 10px; font-size: 14px">
            สร้าง Line OA
          </div>
        </div>
        <hr style="margin-top: 20px;"/>
        <div style="text-align: center;margin-left: 10px">
          <v-avatar color="grey" size="50">
            <span class="white--text text-h7">3</span>
          </v-avatar>
          <div style="white-space: nowrap; margin-top: 10px; font-size: 14px">
            เข้าสู่ระบบ
          </div>
        </div>
      </div>
    </div>
    <div
      class="mt-15"
      style="
        text-align: center;
        font-weight: bolder;
        color: #FFFFFF;
        font-size: 2.5rem;
      "
    >
      <p>เชื่อมต่อ LINE Official Account กับ BeTask</p>
    </div>
    <div class="mb-15" style="text-align: center; font-size: 1.5rem">
      <p style="color: #FFFFFF;">
        บริษัท/ร้านค้าจําเป็นต้องสมัคร LINE Official Account
        กรุณาทําตามขั้นตอนดังนี้
      </p>
    </div>
    <div>
      <v-row>
        <v-col
          :cols="resCol"
          :style="
          (resCol === '6'
            ? 'text-align: center;border-right: 2px solid #ccd1e4;height: 340px;'
            : 'text-align: center;border-bottom: 3px solid #ccd1e4;height: 246px;')
          "
        >
          <div
            style="
              font-weight: bolder;
              color: #FFFFFF;
              font-size: 2rem;
              margin-bottom: 10px;
            "
          >
            กรณีมีบัญชีแล้ว
          </div>
          <div style="font-size: 1.2rem; margin-bottom: 20px;color: #FFFFFF;">
            กรุณาคลิกที่ปุ่ม เชื่อมต่อ LINE OA ด้านล่างนี้
          </div>
          <div style="width: 300px; margin: 0 auto">
            <v-btn
              color="#FFFFFF"
              style="font-size: 20px"
              x-large
              block
              @click="selectLineOa()"
            >
              เชื่อมต่อ LINE OA
            </v-btn>
          </div>
        </v-col>
        <v-col :cols="resCol" style="text-align: center">
          <div
            style="
              font-weight: bolder;
              color: #FFFFFF;
              font-size: 2rem;
              margin-bottom: 10px;
            "
          >
            กรณียังไม่มีบัญชี
          </div>
          <div style="font-size: 1.2rem; margin-bottom: 20px;color: #FFFFFF;">
            กรุณาคลิกที่ปุ่ม สมัครบัญชี LINE OA ด้านล่างนี้และทำตามขั้นตอน
          </div>
          <div style="width: 300px; margin: 0 auto">
            <v-btn
              color="#FFFFFF"
              style="font-size: 20px"
              x-large
              block
              @click="linkToLineOa()"
            >
              สมัครบัญชี LINE OA
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </div>
  </main>
</template>
<script>
// import axios from 'axios' // api
// import moment from 'moment-timezone'
// import PrivacyNotice from '../Welcome/PrivacyNotice.vue'
import Navbar from '../Core/Navbar.vue'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: {
    name: '',
    // PrivacyNotice,
    Navbar,
    'vue-recaptcha': VueRecaptcha
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  data () {
    return {
      linkOA: 'https://manager.line.biz/module/auth/v1/authorize?client_id=1656250423&redirect_uri=https://betask-loyalty-app.web.app/System/ManageShop?productName=loyalty&response_type=code&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=register',
      overlay: false,
      recapStatus: false,
      widthScreen: window.screen.width,
      recapchaToken: '',
      Redirect: '',
      moduleLink: '',
      menuDate: false,
      dialog: false,
      dialogConfirm: false,
      itemdetell: [],
      DataFlowName: [],
      branch: [],
      date: '',
      time: '',
      fromAdd: {
        flowId: null,
        masBranchID: null
      },
      shopId: '',
      bookingField: [],
      Fielditem: [],
      showCard: false,
      FieldSelect: [
        {
          text: 'Field Id',
          value: 'fieldId'
        },
        {
          text: 'Field Name',
          value: 'fieldName'
        },
        { text: 'AC', value: 'showCard' }
      ]
    }
  },
  created () {
    window.addEventListener('resize', this.myEventHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.myEventHandler)
  },
  async mounted () {
    if (this.$route.query.shopId) {
      this.shopId = this.$route.query.shopId
      this.linkOA = `https://manager.line.biz/module/auth/v1/authorize?client_id=1656250423&redirect_uri=https://betask-loyalty-app.web.app/System/ManageShop?productName=loyalty${this.$route.query.shopId}&response_type=code&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=register`
    } else {
    //   window.location.href = 'https://belinked.betaskthai.com/register'
    }
  },
  methods: {
    selectLineOa () {
      this.linkOA = `https://manager.line.biz/module/auth/v1/authorize?client_id=1656250423&redirect_uri=https://betask-loyalty-app.web.app/System/ManageShop?productName=loyalty${this.$route.query.shopId}&response_type=code&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=register`
      window.location = this.linkOA
    },
    linkToLineOa () {
      window.open('https://manager.line.biz', '_blank')
    },
    myEventHandler (e) {
      this.getSceenSize()
    },
    getSceenSize () {
      this.widthScreen = window.innerWidth
    }
  }
}
</script>
<style scoped>
.main {
  padding: 0px;
  background: #ffffff;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
}
.bgPage {
  background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
}
hr {
  border: none;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 50%;
  margin-top: 30px;
}
.bgPage {
  background: url("../../assets/bg.png");
  height: 100%;
  /* left: 0%;
        right: 0%;
        top: 0%;
        bottom: 0%; */
}
</style>



// WEBPACK FOOTER //
// src/components/System/CreateLineOAaccount.vue